(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionnaireTemplateQuestionChoice', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    /**
                     * @property {{
                     *      ODDQuestionType: {
                     *          CategoryCode,
                     *          CategoryBehaviour
                     *      }
                     * }} $scope.boxModel
                     */

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/oddQuestionnaireTemplateQuestionChoice.[Template].tpl.html';

                    $controller('BoxTmplController', {$scope: $scope});
                }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();